import { ApiQueryConfig, ConnectorAppStatus } from 'api/types';
import { URLS } from 'config';
import { createApiEndpoint } from '../utils';

type GetAgentsConfig = ApiQueryConfig<ConnectorAppStatus[]>;

export const getAgents = createApiEndpoint<GetAgentsConfig>({
  method: 'GET',
  url: `${URLS.app}/api/ConnectorApp/Status`,
});
